module.exports = __webpack_public_path__ + "static/media/Patient_consent_form.a39137aa.pdf";